import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo, faPen, faMobileAlt, faArrowRight, faEnvelope, faPhone, faMapMarkerAlt, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';

export default function LandingPage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Détecter la taille de l'écran
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      
      {/* ========== HEADER ========== */}
      <header style={{
        background: '#0a192f',
        padding: '0px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '15px',
        boxShadow: '0 2px 15px rgba(0,0,0,0.1)',
        top: 0,
        zIndex: 100,
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img 
            src="/sos_expert_logo.png" 
            alt="SOS EXPERT" 
            style={{ height: '80px', width: '100px', padding: '0px' }}
          />
        </div>

        {/* Affichage conditionnel selon la taille de l'écran */}
        {isMobile ? (
          // Menu HAMBURGER pour mobile
          <>
            <button 
              onClick={() => setMenuOpen(!menuOpen)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '28px',
                cursor: 'pointer',
                color: '#64a5ff',
              }}
            >
              <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
            </button>
            
            {/* Menu mobile déroulant */}
            {menuOpen && (
              <div style={{
                position: 'fixed',
                top: '80px',
                left: 0,
                right: 0,
                background: '#0a192f',
                boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                zIndex: 99,
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                alignItems: 'center',
              }}>
                <a href="#features" onClick={() => setMenuOpen(false)} style={{ textDecoration: 'none', color: '#64a5ff', fontWeight: '500', fontSize: '16px' }}>Fonctionnalités</a>
                <a href="#how-it-works" onClick={() => setMenuOpen(false)} style={{ textDecoration: 'none', color: '#64a5ff', fontWeight: '500', fontSize: '16px' }}>Comment ça marche</a>
                <a href="#contact" onClick={() => setMenuOpen(false)} style={{ textDecoration: 'none', color: '#64a5ff', fontWeight: '500', fontSize: '16px' }}>Contact</a>
              </div>
            )}
          </>
        ) : (
          // Menu DESKTOP pour PC
          <nav style={{ display: 'flex', gap: '25px' }}>
            <a href="#features" style={{ textDecoration: 'none', color: '#64a5ff', fontWeight: '500' }}>Fonctionnalités</a>
            <a href="#how-it-works" style={{ textDecoration: 'none', color: '#64a5ff', fontWeight: '500' }}>Comment ça marche</a>
            <a href="#contact" style={{ textDecoration: 'none', color: '#64a5ff', fontWeight: '500' }}>Contact</a>
          </nav>
        )}
      </header>

      {/* ========== MAIN AVEC IMAGE DE FOND ========== */}
      <main style={{ 
        flex: 1,
      backgroundImage: 'url(/back.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}>
        
        {/* SECTION HERO (avec fond semi-transparent pour lisibilité) */}
        <section style={{
          background: 'rgba(10, 25, 47, 0.85)',
          color: 'white',
          padding: '80px 40px',
          textAlign: 'center',
        }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h1 style={{ fontSize: '3.5rem', margin: '0 0 20px 0', fontWeight: '700' }}>
              Assistance technique <br/>en réalité augmentée
            </h1>
            <p style={{ fontSize: '1.3rem', marginBottom: '30px', opacity: 0.9 }}>
              Que la distance ne soit plus un frein pour le travail bien fait
            </p>
            <button
              onClick={() => navigate('/home')}
              style={{
                padding: '16px 48px',
                fontSize: '1.2rem',
                background: 'white',
                color: '#0a192f',
                border: 'none',
                borderRadius: '50px',
                cursor: 'pointer',
                fontWeight: 'bold',
                boxShadow: '0 5px 25px rgba(0,0,0,0.2)',
                transition: 'transform 0.2s',
              }}
              onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
            >
               Commencer une démo
            </button>
          </div>
        </section>

        {/* SECTION FONCTIONNALITÉS */}
        <section id="features" style={{ padding: '70px 40px', background: '#f8f9fa' }}>
          <h2 style={{ textAlign: 'center', fontSize: '2.2rem', marginBottom: '50px', color: '#0a192f' }}>
            Fonctionnalités
          </h2>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '40px',
            margin: '0 auto'
          }}>
            
            <div style={{ flex: '1', minWidth: '250px', textAlign: 'center', background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}>
              <FontAwesomeIcon icon={faVideo} size="3x" color="#0a192f" style={{ marginBottom: '20px' }} />
              <h3 style={{ marginBottom: '15px', color: '#0a192f' }}>Flux vidéo en direct</h3>
              <p style={{ color: '#666', lineHeight: '1.6' }}>L'opérateur partage sa caméra en temps réel avec l'expert</p>
            </div>

            <div style={{ flex: '1', minWidth: '250px', textAlign: 'center', background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}>
              <FontAwesomeIcon icon={faPen} size="3x" color="#0a192f" style={{ marginBottom: '20px' }} />
              <h3 style={{ marginBottom: '15px', color: '#0a192f' }}>Annotations en direct</h3>
              <p style={{ color: '#666', lineHeight: '1.6' }}>Flèches, dessins libres, textes placés en temps réel</p>
            </div>

            <div style={{ flex: '1', minWidth: '250px', textAlign: 'center', background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}>
              <FontAwesomeIcon icon={faMobileAlt} size="3x" color="#0a192f" style={{ marginBottom: '20px' }} />
              <h3 style={{ marginBottom: '15px', color: '#0a192f' }}>Multi-plateforme</h3>
              <p style={{ color: '#666', lineHeight: '1.6' }}>Fonctionne sur PC, tablette et smartphone</p>
            </div>

          </div>
        </section>

        {/* SECTION COMMENT ÇA MARCHE */}
        <section id="how-it-works" style={{ padding: '70px 40px', background: 'white' }}>
          <h2 style={{ textAlign: 'center', fontSize: '2.2rem', marginBottom: '50px', color: '#0a192f' }}>
            Comment ça marche ?
          </h2>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '30px',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
            <div style={{ flex: '1', minWidth: '200px', textAlign: 'center' }}>
              <div style={{ width: '60px', height: '60px', background: '#0a192f', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '24px', color: 'white' }}>1</div>
              <h3 style={{ color: '#0a192f' }}>Opérateur</h3>
              <p style={{ color: '#666' }}>Génère un ID de session  et envoie cet ID à un expert par mail pour obtenir de l'aide en temps réel.</p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} size="2x" color="#0a192f" style={{ alignSelf: 'center' }} />
            <div style={{ flex: '1', minWidth: '200px', textAlign: 'center' }}>
              <div style={{ width: '60px', height: '60px', background: '#0a192f', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '24px', color: 'white' }}>2</div>
              <h3 style={{ color: '#0a192f' }}>Expert</h3>
              <p style={{ color: '#666' }}>Rejoint la session à la demande de l'opérateur avec le même ID qui lui sera transmis par l'opérateur dans un mail.</p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} size="2x" color="#0a192f" style={{ alignSelf: 'center' }} />
            <div style={{ flex: '1', minWidth: '200px', textAlign: 'center' }}>
              <div style={{ width: '60px', height: '60px', background: '#0a192f', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '24px', color: 'white' }}>3</div>
              <h3 style={{ color: '#0a192f' }}>Annotation</h3>
              <p style={{ color: '#666' }}>L'expert guide l'opérateur en plaçant des annotations qui s'affichent en temps réel sur l'écran de l'opérateur.</p>
            </div>
          </div>
        </section>

        {/* SECTION CONTACT */}
        <section id="contact" style={{ padding: '70px 40px', background: '#f8f9fa' }}>
          <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
            <h2 style={{ fontSize: '2rem', marginBottom: '20px', color: '#0a192f' }}>Une question ?</h2>
            <p style={{ fontSize: '1.1rem', color: '#555', marginBottom: '30px' }}>
              Contactez-nous pour toute information
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
              <div style={{ textAlign: 'center' }}>
                <FontAwesomeIcon icon={faEnvelope} size="2x" color="#0a192f" />
                <p style={{ marginTop: '8px', fontWeight: '500', color: '#0a192f' }}>contact@sosexpert.com</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <FontAwesomeIcon icon={faPhone} size="2x" color="#0a192f" />
                <p style={{ marginTop: '8px', fontWeight: '500', color: '#0a192f' }}>+229 0152254235</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <FontAwesomeIcon icon={faMapMarkerAlt} size="2x" color="#0a192f" />
                <p style={{ marginTop: '8px', fontWeight: '500', color: '#0a192f' }}>Bénin, Abomey-Calavi</p>
              </div>
            </div>
          </div>
        </section>

      </main>

      {/* ========== FOOTER ========== */}
      <footer style={{
        background: '#0a192f',
        color: '#aaa',
        padding: '40px 40px 20px',
      }}>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          gap: '40px',
          margin: '0 auto'
        }}>
          
          <div>
          <img 
            src="/sos_expert_logo.png" 
            alt="SOS EXPERT" 
            style={{ height: '100px', width: '120px' , top:'20px' , padding:'0px 0px', marginBottom: '0px' }}
        />
            <p style={{ fontSize: '14px', maxWidth: '250px', color: '#aaa', marginTop: '0px' ,padding: '0px 0px' }}>
              Assistance technique à distance avec réalité augmentée
            </p>
          </div>
          
          <div>
            <h4 style={{ color: 'white', marginBottom: '15px' }}>Liens utiles</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '8px' }}><a href="#features" style={{ color: '#aaa', textDecoration: 'none' }}>Fonctionnalités</a></li>
              <li style={{ marginBottom: '8px' }}><a href="#how-it-works" style={{ color:'#aaa', textDecoration: 'none' }}>Comment ça marche</a></li>
              <li><a href="#contact" style={{ color: '#aaa', textDecoration: 'none' }}>Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h4 style={{ color: 'white', marginBottom: '15px' }}>Contact</h4>
            <p style={{ fontSize: '14px', margin: '5px 0', color: '#aaa' }}>
              <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px' }} /> contact@sosexpert.com
            </p>
            <p style={{ fontSize: '14px', margin: '5px 0', color: '#aaa' }}>
              <FontAwesomeIcon icon={faPhone} style={{ marginRight: '8px' }} /> +229 0152254235
            </p>
            <p style={{ fontSize: '14px', margin: '5px 0', color: '#aaa' }}>
              <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: '8px' }} /> Paris, France
            </p>
          </div>
          
          <div>
            <h4 style={{ color: 'white', marginBottom: '15px' }}>Suivez-nous</h4>
            <div style={{ display: 'flex', gap: '15px', fontSize: '24px' }}>
              <FontAwesomeIcon icon={faFacebook} style={{ cursor: 'pointer', color: '#aaa' }} />
              <FontAwesomeIcon icon={faTwitter} style={{ cursor: 'pointer', color: '#aaa' }} />
              <FontAwesomeIcon icon={faInstagram} style={{ cursor: 'pointer', color: '#aaa' }} />
              <FontAwesomeIcon icon={faLinkedin} style={{ cursor: 'pointer', color: '#aaa' }} />
            </div>
          </div>
          
        </div>
        
        <div style={{
          textAlign: 'center',
          marginTop: '40px',
          paddingTop: '20px',
          borderTop: '1px solid #1a365d',
          fontSize: '12px',
          color: '#aaa'
        }}>
          <p>&copy; 2026 SOS EXPERT - Tous droits réservés</p>
        </div>
      </footer>

    </div>
  );
}